import { useEffect } from "react";
import { useQueryState } from "nuqs";
import throttle from "lodash/throttle";

import { WIDGETS_SEARCH_QUERY_PARAM_NAMES } from "@/components/shared/widgets/constants";
import { useDialerDirectCall } from "@/hooks/dialer/use-dialer-direct-call";
import { useAccountDetailsContext } from "@/modules/pipeline/account-details/context";

export const useCallOnStart = () => {
  const [phone, setPhone] = useQueryState(
    WIDGETS_SEARCH_QUERY_PARAM_NAMES.PHONE
  );

  const { contacts } = useAccountDetailsContext();

  const { startDirectCall } = useDialerDirectCall();

  /**
   * Throttle the start call to avoid spamming the server
   * and to avoid calling the server for each key stroke
   */
  const throttledStartCall = throttle(() => {
    /**
     * Reset the phone query param after the call is made
     * or not found in the contacts
     */
    const phoneToCall = phone;
    setPhone(null);

    if (!phoneToCall) return;

    const contact = contacts?.find(
      (contact) =>
        contact.phone === phoneToCall || contact.mobile === phoneToCall
    );

    if (!contact) return;

    if (contact) {
      startDirectCall({
        contact: {
          id: contact.id,
          phone: phoneToCall,
        },
      });
    }
  }, 1000);

  useEffect(() => {
    throttledStartCall();
  }, [contacts, phone]);
};
